export default "__VITE_ASSET__5nx_Y$yM__"